import axios from "@/helpers/axios";
import dayjs from "@/helpers/dayjs";
const commonURL = "/calculator";

export default {
  namespaced: true,
  state: {},
  mutations: {},
  getters: {},
  actions: {
    async calculate({ rootGetters, dispatch }, payload) {
      payload.pickupTime = payload.pickupTime
        ? dayjs(payload.pickupTime).utc().format()
        : payload.pickupTime;

      try {
        const result = await axios({
          method: "post",
          url: `${commonURL}/v3`,
          data: payload,
        });
        return result.data;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
    async calculateFreight({ rootGetters, dispatch }, payload) {
      payload.pickupTime = payload.pickupTime
        ? dayjs(payload.pickupTime).utc().format()
        : payload.pickupTime;

      try {
        const result = await axios({
          method: "post",
          url: `${commonURL}/freight`,
          data: payload,
        });
        return result.data;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
  },
};
